import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { catchError } from 'rxjs/operators';
import { Person } from '../../shared/models/person.model';

@Injectable({
  providedIn: 'root'
})
export class PersonService extends AbstractCRUD<Person> implements CRUDService<Person> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath(): string {
    return '/restricted-list/people';
  }

  public getPeople(body: any): Observable<PaginatedList<Person>> {
    return super.getHTTP().get(`${this.getApiPath()}/all`, {params: body})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public createPerson(body: any): Observable<Person> {
    return super.getHTTP().post(`${this.getApiPath()}`, body)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public getOrCreatePersonFromUserId(id: number): Observable<Person> {
    return super.getHTTP().put(`${this.getApiPath()}/user/${id}`, {})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public updatePerson(id: number, body: any): Observable<Person> {
    return super.getHTTP().put(`${this.getApiPath()}/${id}`, body)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public deletePerson(id: number): Observable<Person> {
    return super.getHTTP().delete(`${this.getApiPath()}/${id}`)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
